import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-service',
  templateUrl: './magic-service.component.html',
  styleUrls: ['./magic-service.component.scss']
})
export class MagicServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
